/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: move-directory-component.ts
 *
 * Created by kyang on 2020-09-23.
 */

function MoveDirectoryModalController (
    this: JS5Object,
    _: JS5Object,
    uiGridConstants: JS5Object,
    FileSystemService: JS5Object,
) {

    //=================//
    // Lifecycle Hooks //
    //=================//

    this.$onInit = () => {
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };

        this.searchText = '';
        this.sourceFileSystemId = this.resolve.sourceFileSystemId;

        FileSystemService
            .getFileSystems()
            .then((fileSystems: JS5Object[]) => {
                _.remove(fileSystems, {id: this.sourceFileSystemId});
                this.gridOptions.data = fileSystems;
            });
    };


    //===================//
    // File Systems Grid //
    //===================//

    const columnDefs = [
        {
            name: 'checkMarkRowHeaderCol',
            field: 'checkMark',
            width: 30,
            enableColumnMenu: false,
            enableSorting: false,
            enableColumnResizing: false,
            cellTemplate: 'components/visual/grid/check-mark-template.html'
        },
        {
            field: 'name',
            type: 'string',
            displayName: 'Name',
            sort: {
                direction: 'asc',
            },
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }, {
            field: 'typeName',
            displayName: 'Type',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }, {
            field: 'pathPrefix',
            displayName: 'Path Prefix',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }
    ];

    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: false,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        multiSelect: false,
        columnDefs: columnDefs,
        onRegisterApi: (gridApi: JS5Object): void => {
            this.gridApi = gridApi;
            this.gridApi.grid.registerRowsProcessor(processGridFilter, 200);
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
        data: []
    };

    let processGridFilter = (renderableRows: JS5Object[]): JS5Object[] => {
        _.forEach(renderableRows, (row: JS5Object): void => {
            if (this.searchText === null || this.searchText === '') {
                row.visible = true;
            } else {
                let criteria: string = this.searchText.toLowerCase();
                row.visible =
                    row.entity.name && row.entity.name.toLowerCase().indexOf(criteria) !== -1 ||
                    row.entity.typeName && row.entity.typeName.toLowerCase().indexOf(criteria) !== -1 ||
                    row.entity.pathPrefix && row.entity.pathPrefix.toLowerCase().indexOf(criteria) !== -1;
            }
        });
        return renderableRows;
    };

    this.executeSearch = (searchText: string): void => {
        this.searchText = searchText;
        this.gridApi.grid.refresh();
    };


    //================//
    // Template Logic //
    //================//

    this.getSelectedCount = (): number => {
        return (
            this.gridApi &&
            this.gridApi.selection &&
            this.gridApi.selection.getSelectedCount()
        );
    };

    this.onOk = (): void => {
        this.close({
            $value: this.gridApi.selection.getSelectedRows()[0]
        });
    };
}

angular
    .module('prism-ui.components')
    .component(
        'moveDirectoryModal',
        {
            controller: MoveDirectoryModalController,
            templateUrl: 'components/modal/moveDirectoryModal/move-directory-modal-template.html',
            bindings: {
                resolve: '<',
                close: '&',
                dismiss: '&'
            }
        }
    );
